window.app = window.app || {};

window.app.recentlyViewed = {
    el: {
        productData: document.querySelector('.mt-product .mt-product-form input[name="id"]'),
        section: document.querySelector('#recently-viewed'),
        carousel: document.querySelector('#recently-viewed .mt-collection__list .swiper'),
        carouselWrapper: document.querySelector('#recently-viewed .mt-collection__list .swiper-wrapper'),
        clearAll: document.querySelector('#recently-viewed .mt-collection__clear-all')
    },
    data: [],
    productsLimit: 8,

    sortProductsById: function (products, data) {
        const productArray = Array.from(products);
        const idOrder = new Map(data.map((id, index) => [id, index]));
        productArray.sort((a, b) => {
            const idA = Number(a.querySelector('input[name="id"]')?.dataset?.productId);
            const idB = Number(b.querySelector('input[name="id"]')?.dataset?.productId);
            const indexA = idOrder.get(idA) ?? Infinity;
            const indexB = idOrder.get(idB) ?? Infinity;

            return indexA - indexB;
        });

        return productArray;
    },

    update: function (productId = null) {
        if (!productId) return;

        const index = this.data.findIndex(item => item === productId);
        (index !== -1) && this.data.splice(index, 1);
        this.data.unshift(productId);
        (this.data.length > this.productsLimit) && this.data.pop();
        window.app.utilities.setCookie('recentlyViewed', JSON.stringify(this.data), 1);
    },

    render: function () {
        const _this = this;
        const currentProductId = _this.el.productData ? Number(JSON.parse(_this.el.productData.dataset.product).id) : null;
        if (_this.el.section === null) return;

        // Get recently viewed products
        let url = Shopify.routes.root + 'search?view=mt-recently-viewed&type=product&q=';
        let query = '';
        _this.data.forEach(productId => (query += `id:${productId} OR `));
        url = url + encodeURIComponent(query);

        fetch(url).then(function (response) {
            return response.text();
        }).then(function (html) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const products = _this.sortProductsById(doc.querySelectorAll('.swiper-slide'), _this.data);
            let productsVisible = 0;

            products.forEach(product => {
                const productId = product.querySelector('[data-product-id]').dataset.productId;
                if (productId == currentProductId) return;
                _this.el.carouselWrapper.appendChild(product);
                productsVisible++;
            });
            _this.el.section.classList.toggle('hidden', (productsVisible === 0));

            // Sort products
            const customCard = _this.el.carouselWrapper.querySelector('.mt-collection-card');
            if (customCard) {
                const customCardIndex = Number(customCard.dataset.index);
                const targetIndex = Math.min(products.length, customCardIndex);
                if (targetIndex === products.length) {
                    _this.el.carouselWrapper.appendChild(customCard.parentElement);
                } else {
                    _this.el.carouselWrapper.insertBefore(customCard.parentElement, products[targetIndex]);
                }
            }

            // Initialize swiper
            _this.slider = new Swiper(_this.el.carousel, {
                slidesPerView: 2,
                spaceBetween: 16,
                navigation: {
                    nextEl: '.mt-collection__nav-btn--next',
                    prevEl: '.mt-collection__nav-btn--prev'
                },
                breakpoints: {
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 16
                    },
                    1200: {
                        slidesPerView: 4,
                        spaceBetween: 16
                    }
                }
            });

            // Inject collection into product JSONs if on a collection page
            const sectionCollection = _this.el.section.dataset.collection;
            if (sectionCollection) {
              _this.el.section.querySelectorAll('.mt-product-form input[name="id"][data-product]').forEach(input => {
                const data = JSON.parse(input.dataset.product);
                if (!data.collection) {
                  data.collection = sectionCollection;
                  input.dataset.product = JSON.stringify(data);
                }
              });
            }

            // Initialize events
            app.productForm.init();
            app.productItem.init();
        });

        // Clear logic
        _this.el.clearAll?.addEventListener('click', e => {
            e.preventDefault();
            _this.data = [];
            window.app.utilities.setCookie('recentlyViewed', JSON.stringify([]), 1);
            _this.el.section.classList.add('hidden');
        });
    },

    init: function () {
        const rvCookie = window.app.utilities.getCookie('recentlyViewed');
        this.data = rvCookie ? JSON.parse(rvCookie) : [];
        this.el.productData && this.update(JSON.parse(this.el.productData.dataset.product).id);
        this.render();
    }
}

window.addEventListener('DOMContentLoaded', () => app.recentlyViewed.init());